import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    // Wait for the turbo-panel controller to be connected and DOM to be ready
    setTimeout(() => {
      this.openPanel()
    }, 100)
  }

  openPanel() {
    if (!this.targetValue) return

    const panel = document.querySelector(this.targetValue)
    if (!panel) return

    // Find the toggle button for this panel
    const toggleButton = document.querySelector(`[data-target="${this.targetValue}"]`)
    if (!toggleButton) return

    // Trigger a click on the toggle button to open the panel
    toggleButton.click()

    // Wait for panel to open and find the comment input
    setTimeout(() => {
      this.focusCommentInput(panel)
    }, 400) // Wait for the 300ms slide animation + buffer
  }

  focusCommentInput(panel) {
    // Try to find the trix editor input (for rich text)
    const trixEditor = panel.querySelector('trix-editor')
    if (trixEditor) {
      trixEditor.focus()
      return
    }

    // Fallback to textarea
    const textarea = panel.querySelector('textarea')
    if (textarea) {
      textarea.focus()
      return
    }

    // Fallback to any text input
    const input = panel.querySelector('input[type="text"]')
    if (input) {
      input.focus()
    }
  }
}
